import { useState } from "react";

import { auth, sendPasswordReset } from "../../util/firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import { Link } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { Input, Button } from "reactstrap";

import { useTranslation } from "react-i18next";

function ResetPasswordPage() {
  const [email, setEmail] = useState("");

  const [loading] = useAuthState(auth);

  const { t } = useTranslation("common");

  if (loading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="loginPage">
      <div className="loginContainer">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h1>{t("resetPassword").toUpperCase()}</h1>
          <p
            className="inputLabel"
            style={{ textAlign: "left", marginTop: "1rem" }}
          >
            {t("email")}
          </p>
          <Input
            type="text"
            className="authInput"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("yourEmail")}
          />
        </div>
        <Button
          className="primaryBtn"
          onClick={() => sendPasswordReset(email, t)}
          style={{ marginTop: "0.5rem" }}
        >
          {t("reset").toUpperCase()}
        </Button>
        <p style={{ marginBottom: 0 }}>
          {t("dontHaveAnAccount")}{" "}
          <Link className="authLink" to="/register">
            {t("register")}
          </Link>{" "}
          {t("here")}.
        </p>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
